// import { FunctionComponent, useEffect, useRef, useState } from "react";
// import CalIcon from "../../assets/task/calendar-icon.svg";
// import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
// import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
// import userICon from "../../assets/task/uses-icon.svg";
// import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
// import { format } from "date-fns";
// import triPledots from '../../assets/task/triple_dot.svg'

// interface InProgressGoalsProps {
//     g: any;
//     handleGoalClick: (id: string) => void;
//     // handleGoalClick: (goalID: string, goalName: string, goalType: string, startGoalDate: string, endGoalDate: string, goalStaticID: string, goalDescription: string) => void;

// }

// const InProgressGoals: FunctionComponent<InProgressGoalsProps> = ({
//     handleGoalClick,
//     g
// }) => {
//     return (
//         <div className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base"
//             onClick={() => handleGoalClick(g?.id)}
//         // onClick={() => handleGoalClick(g?.id, g?.title, 'Ship Production-Ready Features Bi-Weekly', g?.start_date, g?.end_date, g?.goals_static_id, g?.description)}
//         >
//             <div className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2"
//             >
//                 <div className="self-stretch rounded bg-antiquewhite border-orange border-solid border-[1px] flex flex-row items-start justify-center p-2 gap-2.5 text-lg">
//                     <b className="flex-1 relative">{g?.title}</b>
//                     <img className="w-[12px] rounded-[50px] h-[12px] overflow-hidden shrink-0"
//                         alt=""
//                         src={triPledots}
//                     />
//                 </div>
//                 <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                     <div className="flex flex-row items-center justify-center gap-1.5">
//                         {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px]" alt="" src="Group 610.svg" /> */}
//                         <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />

//                         <div className="relative">Schedule</div>
//                     </div>
//                     <div className="flex flex-row items-center justify-center text-dimgray">
//                         <div className="relative whitespace-pre-wrap">{`${format(g?.start_date, 'MMM dd')} - ${format(g?.end_date, 'MMM dd')}`}</div>
//                     </div>
//                 </div>
//                 <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                     <div className="flex flex-row items-center justify-center gap-1.5">
//                         {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="task_svgrepo.com.svg" /> */}
//                         <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIconcheck} />
//                         <div className="relative">Actual</div>
//                     </div>
//                     <div className="flex flex-row items-center justify-center text-dimgray">
//                         <div className="relative whitespace-pre-wrap">{`${format(g?.actual_start_date, 'MMM dd')} - N/A`}</div>
//                     </div>
//                 </div>
//                 <hr className="bdr-custom-taskcrad" />
//                 <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                     <div className="flex flex-row items-center justify-center gap-1.5">
//                         {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="users_svgrepo.com.svg" /> */}
//                         <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userICon} />
//                         <div className="relative">Members</div>
//                     </div>
//                     <div className="w-6 relative h-6 shrink-0 ml-[-7px] flex justify-end items-center">
//                         <div className="flex flex-row items-start justify-end">
//                             <div className="mermbers_count_goal absolute top-[3px] left-[-35px]">
//                                 <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                             </div>
//                             <div className="mermbers_count_goal absolute top-[3px] left-[-22px]">
//                                 <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                             </div>
//                             <div className="mermbers_count_goal absolute top-[3px] left-[-8px]">
//                                 <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                             </div>
//                             <div className="w-6 relative h-6 overflow-hidden shrink-0 ml-[-7px]">
//                                 <div className="absolute top-[calc(50%_-_9px)] left-[calc(50%_-_6px)] mermbers_count_goal">{g?.goal_members?.length}</div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                     <div className="flex flex-row items-center justify-center gap-1.5">
//                         {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="task-square_svgrepo.com.svg" /> */}
//                         <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={taskIcons} />
//                         <div className="relative">Tasks</div>
//                     </div>
//                     <div className="flex flex-row items-center justify-center text-dimgray">
//                         <div className="relative">{`${g?.number_of_completed_tasks}/${g?.number_of_tasks}`}</div>
//                     </div>
//                 </div>
//                 <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2 text-lightseagreen">
//                     {/* <div className="flex-1 relative h-0.5">
//                                                             <div className="absolute top-[0px] left-[0px] rounded-[25px] bg-whitesmoke-300 w-[129px] h-0.5" />
//                                                             <div className="absolute top-[0px] left-[0px] rounded-[25px] bg-lightseagreen w-[65px] h-0.5" />
//                                                         </div> */}
//                     {g?.goal_tags_values?.length > 0 && (
//                         g?.goal_tags_values?.map((gt: any) => {
//                             return (
//                                 <div className="relative">
//                                     {/* <span>50%</span> */}
//                                     <span className="text-dimgray"> {gt?.tags_name}</span>
//                                 </div>
//                             )

//                         })
//                     )}
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default InProgressGoals;

//     function handleGoalClick(goalID: string, goalName: string, goalType: string, startGoalDate: string, endGoalDate: string, goalStaticID: string, goalDescription: string) {
//     // navigate('/goal_view', {
//     //     state: {
//     //         goalID: goalID,
//     //         projectName: projectName,
//     //         projectMembers: projectMembers,
//     //     }
//     // })

//     navigate('/edit_goal', {
//         state: {
//             projectName: projectName,
//             projectID: projectID,
//             goalName: goalName,
//             goalID: goalID,
//             goalType: goalType,
//             startGoalDate: startGoalDate,
//             endGoalDate: endGoalDate,
//             goalStaticID: goalStaticID,
//             goalDescription: goalDescription
//         }
//     })
// }

import { FunctionComponent, useState, useRef, useEffect } from "react";
import CalIcon from "../../assets/task/calendar-icon.svg";
import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
import userICon from "../../assets/task/uses-icon.svg";
import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
import { format } from "date-fns";
import triPledots from '../../assets/task/triple_dot.svg';
import { useNavigate } from "react-router-dom";

interface InProgressGoalsProps {
    g: any;
    handleGoalClick: (id: string) => void;
    projectMembers: any
}

const InProgressGoals: FunctionComponent<InProgressGoalsProps> = ({
    handleGoalClick,
    g,
    projectMembers
}) => {
    const navigate = useNavigate()
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLImageElement>(null); // Ref for the triple dot button

    const toggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent the goal click from being triggered
        setShowMenu(prev => !prev);
    };

    // Close the menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Check if the click is outside the menu AND not on the toggle button
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Optional: Functions for handling menu actions (implement in parent or here with callbacks)
    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation();

        if (g?.is_template) {
      navigate("/edit_goal_from_template", {
        state: {
          goalID: g?.id,
          projectName: g?.project_name,
        },
      });
    } else {
      navigate("/edit_goal", {
        state: {
          projectName: g?.project_name,
          projectID: g?.project_id,
          goalID: g?.id,
          goalMembers: g?.goal_members,
          projectMembers: projectMembers,
        },
      });
    }
        setShowMenu(false);
    };

    // const handleArchive = (e: React.MouseEvent) => {
    //     e.stopPropagation();
    //     console.log(`Archive Goal: ${g?.id}`);
    //     setShowMenu(false);
    // };

    return (
        <div
            className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base cursor-pointer" // Add cursor-pointer for better UX
            onClick={() => handleGoalClick(g?.id)}
        >
            <div className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2">
                <div className="self-stretch rounded bg-antiquewhite border-orange border-solid border-[1px] flex flex-row items-start justify-between p-2 gap-2.5 text-lg relative"> {/* Added relative here for positioning the menu */}
                    <b className="flex-1 relative">{g?.title}</b>
                    <img
                        ref={buttonRef} // Assign the ref to the button
                        className="w-4 h-4 relative rounded-[50px] overflow-hidden shrink-0 cursor-pointer"
                        alt="Options"
                        src={triPledots}
                        onClick={toggleMenu}
                    />

                    {/* Menu Pop-up */}
                    {showMenu && (
                        <div
                            ref={menuRef} // Assign the ref to the menu container
                            className="absolute right-0 top-full mt-2 w-32 bg-white border border-gray-200 rounded shadow-lg z-10" // Adjust styling as needed
                            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the menu
                        >
                            <div
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                onClick={handleEdit}
                            >
                                Edit Goal
                            </div>
                            {/* <div
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                onClick={handleArchive}
                            >
                                Archive Goal
                            </div> */}
                        </div>
                    )}
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    {/* <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                        <div className="relative">Outcome</div>
                    </div> */}
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <b className="relative whitespace-pre-wrap">{g?.goal_static_outcome}</b>
                    </div>
                </div>
                <hr className="bdr-custom-taskcrad" />
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={CalIcon} />
                        <div className="relative">Schedule</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative whitespace-pre-wrap">{`${format(g?.start_date, 'MMM dd')} - ${format(g?.end_date, 'MMM dd')}`}</div>
                    </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={CalIconcheck} />
                        <div className="relative">Actual</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative whitespace-pre-wrap">{`${format(g?.actual_start_date, 'MMM dd')} - N/A`}</div>
                    </div>
                </div>
                <hr className="bdr-custom-taskcrad" />
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={userICon} />
                        <div className="relative">Facilitator</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative">{g?.created_by_name || 'N/A'}</div>
                    </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={userICon} />
                        <div className="relative">Members</div>
                    </div>
                    <div className="relative group inline-block">
                        {/* Count */}
                        <div className="px-2 py-1 bg-gray-100 rounded-lg border text-sm cursor-pointer count-dark-bg-dv">
                            {g?.goal_members?.length || 0}
                        </div>

                        {/* Hover Tooltip/List */}
                        {g?.goal_members?.length > 0 && (
                            <div className="absolute top-8 left-0 hidden group-hover:block bg-white shadow-lg rounded-lg p-2 w-48 z-50">
                                <ul className="text-sm text-gray-700 max-h-40 overflow-y-auto">
                                    {g?.goal_members?.map((member: any, i: number) => (
                                        <li
                                            key={i}
                                            className="py-1 px-2 hover:bg-gray-100 rounded  dark:text-white"
                                        >
                                            {member?.member_name || `Member ${i + 1}`}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    {/* <div className="w-6 relative h-6 shrink-0 ml-[-7px] flex justify-end items-center">
                        <div className="flex flex-row items-start justify-end">
                            {g?.goal_members?.slice(0, 3).map((member: any, index: number) => (
                                <div key={index} className={`mermbers_count_goal absolute top-[3px] left-[${-35 + (index * 13)}px]`}>
                                    <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={userCricleimg} />
                                </div>
                            ))}
                            {g?.goal_members?.length > 3 && (
                                <div className="w-6 relative h-6 overflow-hidden shrink-0 ml-[-7px]">
                                    <div className="absolute top-[calc(50%_-_9px)] left-[calc(50%_-_6px)] mermbers_count_goal">
                                        +{g?.goal_members?.length - 3}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={taskIcons} />
                        <div className="relative">Tasks</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative">{`${g?.number_of_completed_tasks}/${g?.number_of_tasks}`}</div>
                    </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2 text-lightseagreen">
                    {g?.goal_tags_values?.length > 0 && (
                        g?.goal_tags_values?.map((gt: any) => {
                            // Ensure "Delayed" tag is not displayed here as it's filtered out in the parent for this section
                            if (gt.tags_name !== "Delayed") {
                                return (
                                    <div className="relative" key={gt.id}>
                                        <span className="text-dimgray"> {gt?.tags_name}</span>
                                    </div>
                                );
                            }
                            return null;
                        })
                    )}
                </div>
            </div>
        </div>
    )
}

export default InProgressGoals;